/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { AssetType, AssetTypeFromJSON, AssetTypeFromJSONTyped, AssetTypeToJSON } from "./AssetType";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";

/**
 *
 * @export
 * @interface AssetTypeListControllerResponse
 */
export interface AssetTypeListControllerResponse {
  /**
   *
   * @type {Array<AssetType>}
   * @memberof AssetTypeListControllerResponse
   */
  data?: Array<AssetType> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof AssetTypeListControllerResponse
   */
  error?: ErrorResponse;
}

export function AssetTypeListControllerResponseFromJSON(json: any): AssetTypeListControllerResponse {
  return AssetTypeListControllerResponseFromJSONTyped(json, false);
}

export function AssetTypeListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AssetTypeListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(AssetTypeFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function AssetTypeListControllerResponseToJSON(value?: AssetTypeListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
        ? null
        : (value.data as Array<any>).map(AssetTypeToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
